import { setTaskDetailExtract as setTaskDetailExtractDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type Props = {
    type?: string;
}

export const setTaskDetailExtract = ({
    type,
}: Props) => setTaskDetailExtractDiagram({
    type,
});
